const INITIAL_STATE = {
  data: {},
  slots: [],
  slotsDate: null,
  slotsSpecialistKey: null,
  bookingResponse: '',
  viewedSalons: [],
  historyAppointments: [],
  upcomingAppointments: [],
  pendingAppointments: [],
  isLoggedIn: false,
  // Is a salon fetch in flight right now? Read by <SplashGate/> to tell
  // "this route is still loading the business" apart from "this route never
  // fetches a business at all" (/shop, /checkout, /p/:id, /orders/:id … never
  // dispatch getSalonSpecificInfo). Without it the splash would sit on top of
  // those pages until its safety timeout.
  salonLoading: false,
};

const getSalonReducer = (state = INITIAL_STATE, action) => {
  // console.log("sad", action)
  switch (action.type) {
    case "GET_SALON_INFO_START":
      return {
        ...state,
        salonLoading: true,
      };
    // Both fetch actions dispatch GET_SALON_INFO on success AND on failure
    // (with an empty payload), so this single case clears the flag either way.
    case "GET_SALON_INFO":
      return {
        ...state,
        data: action.payload,
        salonLoading: false,
      };
    case "GET_SLOTS": {
      const p = action.payload;
      const isEnvelope = p && typeof p === "object" && !Array.isArray(p) && "slots" in p;
      return {
        ...state,
        slots: isEnvelope ? (p.slots ?? []) : (p ?? []),
        slotsDate: isEnvelope ? (p.date ?? null) : null,
        slotsSpecialistKey: isEnvelope ? (p.specialistKey ?? null) : null,
        // An empty list means one of two very different things. Every SUCCESS
        // clears this; only a thrown request sets it. The screen must not call
        // a failed request a fully-booked day.
        slotsFailed: isEnvelope ? p.slotsFailed === true : false,
      };
    }
    case "SEND_BOOKING":
      return {
        ...state,
        bookingResponse: action.payload,
      };

    case "GET_VIEWED_SALONS":
      return {
        ...state,
        viewedSalons: action.payload,
      };
    
    case "GET_HISTORY_APPOINTMENTS":
      return {
        ...state,
        historyAppointments: action.payload,
      };
    case "GET_UPCOMING_APPOINTMENTS":
      return {
        ...state,
        upcomingAppointments: action.payload,
      };
    case "GET_PENDING_APPOINTMENTS":
      return {
        ...state,
        pendingAppointments: action.payload,
      };
    case "LOGOUT":
      return {
        ...state,
        isLoggedIn: false,
        upcomingAppointments: [],
        historyAppointments: [],
        pendingAppointments: [],
        viewedSalons: [],
      };

    case "LOGIN":
      return {
        ...state,
        isLoggedIn: true,
        upcomingAppointments: [],
        historyAppointments: [],
        pendingAppointments: [],
        viewedSalons: [],
      };
    default:
      return state;
  }
};
export { getSalonReducer };
